import { gql } from 'graphql-request';

export const GET_STAFF_OUTGOING_INVITES_COUNT = gql`
  query CoreEmployeeInvitations {
    coreEmployeeInvitations {
      count(filter: { isIncoming: null })
    }
  }
`;
